import { Link } from "react-router-dom";

const HomePageMain = () => {
    return (
        <div>
            <div className="site-main">
                <section className="ttm-row welcome-section clearfix">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-8">
                                <div className="d-flex">
                                    <div className="col">
                                        <div className="ttm_single_image-wrapper pt-60">
                                            <img width="270" height="386" className="img-fluid" src="/images/about-1.jpg" alt="single_02"
                                                style={{
                                                    height: "386px",
                                                    width: "270px",
                                                    objectFit: "cover"
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="ttm_single_image-wrapper">
                                            <img width="270" height="448" className="img-fluid" src="/images/about-2.jpg" alt="single_03"
                                                style={{
                                                    height: "386px",
                                                    width: "270px",
                                                    objectFit: "cover"
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="pt-10 res-991-pt-0 res-991-mt-40">
                                    <div className="section-title">
                                        <div className="title-heade">
                                            <h3>About Us</h3>
                                            <h2 className="title">Unparalleled, Award-Winning Interior Design Services</h2>
                                        </div>
                                    </div>
                                    <div className="d-flex pl-5 mt-30 mb-30 ttm-bgcolor-skincolor position-relative z-index-2">
                                        <div className="d-inline pl-20 w-100 ttm-bgcolor-white ttm-textcolor-darkgrey">
                                            <p className="mb-0 font-size-18 fontweight-Medium"><i>Transforming Spaces with Signature Expertise</i></p>
                                        </div>
                                    </div>
                                    <div className="pb-10 res-991-pb-30">
                                        <p>At Kritajna Homes, our renowned interior design process is tailored to provide an exceptional experience, whether you’re refreshing a room, remodeling a space, renovating an old flat, or starting from scratch. With over 15 years of expertise, we specialize in transforming living spaces into personalized havens that blend style, functionality, and comfort. Our seamless and client-focused approach ensures your design journey is exciting, stress-free, and fully aligned with your unique vision. Let Kritajna Homes turn your dream interior into a reality—your one-stop destination for elegant interior solutions.</p>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Link className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-darkgrey mr-30" to="/contact-us" tabIndex={0}>Contact Us</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ttm-row services-section ttm-bgcolor-grey bg-img1 clearfix">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="pt-10 text-left res-575-mb-15">
                                    <div className="section-title">
                                        <div className="title-header">
                                            <h3>Services</h3>
                                            <h2 className="title">Services We’re <strong className="ttm-textcolor-skincolor">Providing</strong></h2>
                                        </div>
                                        <p>Made name within the industry for interiors that are intelligent, elegant & infused with passion</p>
                                    </div>
                                    <Link className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-darkgrey mt-15 res-991-mt-0" to="/architecture" tabIndex={0}>Know More</Link>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="featured-imagebox featured-imagebox-portfolio style2">
                                    <div className="featured-thumbnail">
                                        <a href="/"><img width="740" height="576" className="img-fluid" src="https://via.placeholder.com/740x576/808080?text=740x576+portfolio-01-740x576.jpg" alt="" /></a>
                                    </div>
                                    <div className="featured-content">
                                        <div className="featured-icon">
                                            <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                                <i className="flaticon flaticon-workspace"></i>
                                            </div>
                                        </div>
                                        <div className="featured-title">
                                            <h3>Architecture</h3>
                                        </div>
                                        <div className="featured-desc">
                                            <p>We develop the full cycle of project documentation & full details. Our clients satisfaction is most</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="featured-imagebox featured-imagebox-portfolio style2">
                                    <div className="featured-thumbnail">
                                        <a href="/"><img width="740" height="576" className="img-fluid" src="https://via.placeholder.com/740x576/808080?text=740x576+portfolio-03-740x576.jpg" alt="" /></a>
                                    </div>
                                    <div className="featured-content">
                                        <div className="featured-icon">
                                            <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                                <i className="flaticon flaticon-staircase"></i>
                                            </div>
                                        </div>
                                        <div className="featured-title">
                                            <h3>Interior Work</h3>
                                        </div>
                                        <div className="featured-desc">
                                            <p>We will take care of the interior designs, build & management of all kind of living projects</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="featured-imagebox featured-imagebox-portfolio style2 active">
                                    <div className="featured-thumbnail">
                                        <a href="/"><img width="740" height="576" className="img-fluid" src="https://via.placeholder.com/740x576/808080?text=740x576+portfolio-04-740x576.jpg" alt="" /></a>
                                    </div>
                                    <div className="featured-content">
                                        <div className="featured-icon">
                                            <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                                <i className="flaticon flaticon-stairs"></i>
                                            </div>
                                        </div>
                                        <div className="featured-title">
                                            <h3>2D/3D Layouts</h3>
                                        </div>
                                        <div className="featured-desc">
                                            <p>We offer professional online 2D and 3D interior designing  which will help you visualize</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="featured-imagebox featured-imagebox-portfolio style2">
                                    <div className="featured-thumbnail">
                                        <a href="/"><img width="740" height="576" className="img-fluid" src="https://via.placeholder.com/740x576/808080?text=740x576+portfolio-05-740x576.jpg" alt="" /></a>
                                    </div>
                                    <div className="featured-content">
                                        <div className="featured-icon">
                                            <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                                <i className="flaticon flaticon-decorating"></i>
                                            </div>
                                        </div>
                                        <div className="featured-title">
                                            <h3>Decoration art</h3>
                                        </div>
                                        <div className="featured-desc">
                                            <p>There are many lorram variations of passages of available but the majority have simply free text.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ttm-row bottom_zero_padding-section mt_10 res-991-mt-0 bg-layer-equal-height clearfix">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-10 col-md-8">
                                <div className="section-title style2">
                                    <div className="title-header">
                                        <h3>What's new</h3>
                                        <h2 className="title">Completed Projects</h2>
                                    </div>
                                    <div className="title-desc">
                                        <p>Each project is designed with close attention to the detail, managed and implemented with great care. We work with craftsmen and bespoke</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-4">
                                <Link className="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-border ttm-btn-color-darkgrey mt-10 mb-10 float-md-right res-991-mb-30 res-991-mt-0" to="/projects">View More</Link>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="tm_coverimgbox_wrapper">
                                <div className="tm_coverbox_contents">
                                    <div className="featured-content">
                                        <div className="featured-title">
                                            <h3>Intirior</h3>
                                        </div>
                                        <div className="featured-desc">
                                            <p>We will take care of the interior designs, build and management of all kind of living projects</p>
                                        </div>
                                        {/* <div className="ttm-footer">
                                            <a className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-white" href="architecture.html" tabIndex={0}>Read More</a>
                                        </div> */}
                                    </div>
                                    <div className="coverbox-img-reposive">
                                        <img width="1920" height="720" className="img-fluid" src="/images/project-1.png" alt="images" />
                                    </div>
                                </div>
                                <div className="tm_coverbox_img active">
                                    <div className="tm_box_overlay"></div>
                                    <div className="tm-stepbox-imagebox">
                                        <div className="tm-ptable-icon-type-image">
                                            <img width="1920" height="720" className="img-fluid" src="/images/project-1.png" alt="images" />
                                        </div>
                                    </div>
                                </div>
                                <div className="tm_coverbox_contents">
                                    <div className="featured-content">
                                        <div className="featured-title">
                                            <h3>Modern Kitchen</h3>
                                        </div>
                                        <div className="featured-desc">
                                            <p>The style of the interior was defined modern in light colors. The main materials used in the project.</p>
                                        </div>
                                        {/* <div className="ttm-footer">
                                            <a className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-white" href="decoration-art.html" tabIndex={0}>Read More</a>
                                        </div> */}
                                    </div>
                                    <div className="coverbox-img-reposive">
                                        <img width="1920" height="720" className="img-fluid" src="/images/project-1.png" alt="images" />
                                    </div>
                                </div>
                                <div className="tm_coverbox_img">
                                    <div className="tm_box_overlay"></div>
                                    <div className="tm-stepbox-imagebox">
                                        <div className="tm-ptable-icon-type-image">
                                            <img width="1920" height="720" className="img-fluid" src="/images/project-1.png" alt="images" />
                                        </div>
                                    </div>
                                </div>
                                <div className="tm_coverbox_contents">
                                    <div className="featured-content">
                                        <div className="featured-title">
                                            <h3>Prestige Villa</h3>
                                        </div>
                                        <div className="featured-desc">
                                            <p>Prestige villa exterior design thought and decided that in such a case it would be wise to use porcelain stoneware.</p>
                                        </div>
                                        {/* <div className="ttm-footer">
                                            <a className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-white" href="layout.html" tabIndex={0}>Read More</a>
                                        </div> */}
                                    </div>
                                    <div className="coverbox-img-reposive">
                                        <img width="1920" height="720" className="img-fluid" src="/images/project-1.png" alt="images" />
                                    </div>
                                </div>
                                <div className="tm_coverbox_img">
                                    <div className="tm_box_overlay"></div>
                                    <div className="tm-stepbox-imagebox">
                                        <div className="tm-ptable-icon-type-image">
                                            <img width="1920" height="720" className="img-fluid" src="/images/project-1.png" alt="images" />
                                        </div>
                                    </div>
                                </div>
                                <div className="tm_coverbox_contents">
                                    <div className="featured-content">
                                        <div className="featured-title">
                                            <h3>Family Apartment</h3>
                                        </div>
                                        <div className="featured-desc">
                                            <p>An apartment, or flat is a self-contained housing unit type of residential occupies only part of a building.</p>
                                        </div>
                                        {/* <div className="ttm-footer">
                                            <a className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-white" href="interior-work.html" tabIndex={0}>Read More</a>
                                        </div> */}
                                    </div>
                                    <div className="coverbox-img-reposive">
                                        <img width="1920" height="720" className="img-fluid" src="/images/project-1.png" alt="images" />
                                    </div>
                                </div>
                                <div className="tm_coverbox_img">
                                    <div className="tm_box_overlay"></div>
                                    <div className="tm-stepbox-imagebox">
                                        <div className="tm-ptable-icon-type-image">
                                            <img width="1920" height="720" className="img-fluid" src="/images/project-1.png" alt="images" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <section className="ttm-row bolg-section clearfix">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 col-md-8 col-sm-10 m-auto">
                                <div className="section-title title-style-center_text">
                                    <div className="title-header">
                                        <h3>News About Our Company</h3>
                                        <h2 className="title">Read About Interior</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row slick_slider mt-20 res-991-mt-0" data-slick='{"slidesToShow": 3, "slidesToScroll": 1, "arrows":false, "autoplay":false, "infinite":true, "responsive": [{"breakpoint":992,"settings":{"slidesToShow": 2}}, {"breakpoint":576,"settings":{"slidesToShow": 1}}]}'>
                            <div className="ttm-box-col-wrapper col-lg-4">
                                <div className="featured-imagebox featured-imagebox-post style2">
                                    <div className="featured-imagebox-post-inner">
                                        <div className="featured-thumbnail">
                                            <img width="650" height="510" className="img-fluid" src="https://via.placeholder.com/650x510/808080?text=650x510+blog-01-650x510.jpg" alt="" />
                                        </div>
                                        <div className="ttm-box-post-date">
                                            <span className="ttm-entry-date">
                                                <time className="entry-date" dateTime="2019-01-16T07:07:55+00:00">05<span className="entry-month entry-year">Jun</span></time>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="featured-content">
                                        <div className="post-meta">
                                            <span className="ttm-meta-line"><i className="ti ti-user ttm-textcolor-skincolor"></i>John Doe</span>
                                            <span className="ttm-meta-line"><i className="ti ti-comment ttm-textcolor-skincolor"></i>0 Comments</span>
                                        </div>
                                        <div className="featured-title">
                                            <h3><a href="blog-single.html">Things to Know When Choosing the Perfect Sofa</a>
                                            </h3>
                                        </div>
                                        <div className="featured-desc">A small newly opened interior design business that aims to cover different issue...</div>
                                    </div>
                                </div>
                            </div>
                            <div className="ttm-box-col-wrapper col-lg-4">
                                <div className="featured-imagebox featured-imagebox-post style2">
                                    <div className="featured-imagebox-post-inner">
                                        <div className="featured-thumbnail">
                                            <img width="650" height="510" className="img-fluid" src="https://via.placeholder.com/650x510/808080?text=650x510+blog-02-650x510.jpg" alt="" />
                                        </div>
                                        <div className="ttm-box-post-date">
                                            <span className="ttm-entry-date">
                                                <time className="entry-date" dateTime="2019-01-16T07:07:55+00:00">23<span className="entry-month entry-year">May</span></time>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="featured-content">
                                        <div className="post-meta">
                                            <span className="ttm-meta-line"><i className="ti ti-user ttm-textcolor-skincolor"></i>John Doe</span>
                                            <span className="ttm-meta-line"><i className="ti ti-comment ttm-textcolor-skincolor"></i>0 Comments</span>
                                        </div>
                                        <div className="featured-title">
                                            <h3><a href="blog-single.html">Colour Schemes to Introduce Spring in Your Home</a></h3>
                                        </div>
                                        <div className="featured-desc">A small newly opened interior design business that aims to cover different issue...</div>
                                    </div>
                                </div>
                            </div>
                            <div className="ttm-box-col-wrapper col-lg-4">
                                <div className="featured-imagebox featured-imagebox-post style2">
                                    <div className="featured-imagebox-post-inner">
                                        <div className="featured-thumbnail">
                                            <img width="650" height="510" className="img-fluid" src="https://via.placeholder.com/650x510/808080?text=650x510+blog-03-650x510.jpg" alt="" />
                                        </div>
                                        <div className="ttm-box-post-date">
                                            <span className="ttm-entry-date">
                                                <time className="entry-date" dateTime="2019-01-16T07:07:55+00:00">15<span className="entry-month entry-year">May</span></time>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="featured-content">
                                        <div className="post-meta">
                                            <span className="ttm-meta-line"><i className="ti ti-user ttm-textcolor-skincolor"></i>John Doe</span>
                                            <span className="ttm-meta-line"><i className="ti ti-comment ttm-textcolor-skincolor"></i>0 Comments</span>
                                        </div>
                                        <div className="featured-title">
                                            <h3><a href="blog-single.html">4 Ways to Create Extra Space in Small Homes</a></h3>
                                        </div>
                                        <div className="featured-desc">A small newly opened interior design business that aims to cover different issue...</div>
                                    </div>
                                </div>
                            </div>
                            <div className="ttm-box-col-wrapper col-lg-4">
                                <div className="featured-imagebox featured-imagebox-post style2">
                                    <div className="featured-imagebox-post-inner">
                                        <div className="featured-thumbnail">
                                            <img width="650" height="510" className="img-fluid" src="https://via.placeholder.com/650x510/808080?text=650x510+blog-04-650x510.jpg" alt="" />
                                        </div>
                                        <div className="ttm-box-post-date">
                                            <span className="ttm-entry-date">
                                                <time className="entry-date" dateTime="2019-01-16T07:07:55+00:00">20<span className="entry-month entry-year">Mar</span></time>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="featured-content">
                                        <div className="post-meta">
                                            <span className="ttm-meta-line"><i className="ti ti-user ttm-textcolor-skincolor"></i>John Doe</span>
                                            <span className="ttm-meta-line"><i className="ti ti-comment ttm-textcolor-skincolor"></i>0 Comments</span>
                                        </div>
                                        <div className="featured-title">
                                            <h3><a href="blog-single.html">Will My Project be Unveiled to Me?</a></h3>
                                        </div>
                                        <div className="featured-desc">A small newly opened interior design business that aims to cover different issue...</div>
                                    </div>
                                </div>
                            </div>
                            <div className="ttm-box-col-wrapper col-lg-4">
                                <div className="featured-imagebox featured-imagebox-post style2">
                                    <div className="featured-imagebox-post-inner">
                                        <div className="featured-thumbnail">
                                            <img width="650" height="510" className="img-fluid" src="https://via.placeholder.com/650x510/808080?text=650x510+blog-05-650x510.jpg" alt="" />
                                        </div>
                                        <div className="ttm-box-post-date">
                                            <span className="ttm-entry-date">
                                                <time className="entry-date" dateTime="2019-01-16T07:07:55+00:00">20<span className="entry-month entry-year">Mar</span></time>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="featured-content">
                                        <div className="post-meta">
                                            <span className="ttm-meta-line"><i className="ti ti-user ttm-textcolor-skincolor"></i>John Doe</span>
                                            <span className="ttm-meta-line"><i className="ti ti-comment ttm-textcolor-skincolor"></i>0 Comments</span>
                                        </div>
                                        <div className="featured-title">
                                            <h3><a href="blog-single.html">What is the Process For Purchasing Furniture?</a></h3>
                                        </div>
                                        <div className="featured-desc">A small newly opened interior design business that aims to cover different issue...</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
            </div>
        </div>
    )
}

export default HomePageMain;